<template>
   <div>
      <v-container>
         <v-row justify="center" class="pt-3">
            <v-col cols="12" md="9">
               <v-row>
                  <v-toolbar dense :color="this.$globalstore.secondary_titleclass" bottom>
                     <v-toolbar-title> Add User </v-toolbar-title>
                     <v-spacer></v-spacer>
                     <v-btn color="indigo" class="white ma-2" outlined @click="goBack()">
                        Cancel
                     </v-btn>
                     <v-btn color="indigo" class="white ma-2" outlined @click="SaveUser">
                        Save
                     </v-btn>
                  </v-toolbar>
               </v-row>
               <!-- 
               token_expiry, last_login, userlink_id -->
               <v-form ref="userform" v-model="userform_valid">
                  <v-row class="pt-2">
                     <v-col cols="12" md="8">
                        <v-card flat outlined class="px-2">
                           <v-text-field label="User Name" v-model="edit_user_name" required>
                           </v-text-field>
                           <v-text-field label="Email" v-model="edit_user_email" required>
                           </v-text-field>
                        </v-card>
                     </v-col>
                     <v-col cols="12" md="4">
                        <v-card flat outlined class="px-2">
                           <v-select
                              label="User Type"
                              :items="$globalstore.usertype_select"
                              item-text="text"
                              item-value="id"
                              return-object
                              v-model="edit_user_type"
                              required
                           ></v-select>

                           <v-select
                              label="Status"
                              :items="$globalstore.status_select"
                              item-text="text"
                              item-value="id"
                              return-object
                              v-model="edit_user_status"
                              required
                           >
                           </v-select>
                        </v-card>
                     </v-col>
                  </v-row>
               </v-form>

               <v-row class="py-1">
                  <v-col cols="12" md="6">
                     <v-row>
                        <v-col cols="12">
                           <v-card flat outlined class="px-2">
                              <div class="py-2">
                                 <b>Roles</b>
                                 <v-btn x-small fab class="primary ml-4" @click="addRole">
                                    <v-icon>mdi-plus</v-icon>
                                 </v-btn>
                                 <v-btn x-small fab class="primary ml-2" @click="removeRole">
                                    <v-icon>mdi-minus</v-icon>
                                 </v-btn>
                              </div>
                           </v-card>
                        </v-col>
                     </v-row>
                     <v-card flat outlined class="px-2">
                        <v-data-table
                           dense
                           :headers="roletable_headers"
                           hide-default-header
                           hide-default-footer
                           item-key="role_id"
                           :items="userroledata"
                           @click:row="onUserRoleClick"
                           single-select
                        >
                        </v-data-table>
                     </v-card>
                  </v-col>

                  <v-col cols="12" md="6">
                     <v-row>
                        <v-col cols="12">
                           <v-card flat outlined class="px-2">
                              <div class="py-3">
                                 <b>Capabilities</b>
                              </div>
                           </v-card>
                        </v-col>
                     </v-row>
                     <v-card flat outlined>
                        <v-data-table
                           dense
                           :headers="captable_headers"
                           hide-default-header
                           hide-default-footer
                           :items="rolecaplist"
                           item-key="cap_id"
                           single-select
                           @click:row="captableRowClick"
                        >
                        </v-data-table>
                     </v-card>
                  </v-col>
               </v-row>
            </v-col>
         </v-row>
      </v-container>
      <role-list
         :roledata="userroledata"
         :dialogvisible.sync="roledlg"
         @save-selection="onRoleSelect"
         @cancel-selection="roledlg = false"
      ></role-list>
   </div>
</template>

<script>
   import RoleList from "@/components/RoleList.vue";

   export default {
      components: {RoleList},
      data() {
         return {
            edit_user_name: "",
            edit_user_email: "",
            edit_user_status: null,
            edit_user_type: null,
            edit_user_role: null,
            user_lastlogin: "",
            user_tokenexpiry: "",
            userform_valid: true,
            roletable_headers: [
               {text: "Role", value: "role_name"},
               {text: "Description", value: "role_description"},
            ],
            captable_headers: [
               {text: "ID", value: "cap_id"},
               {text: "Capability", value: "cap_name"},
            ],
            rolelist: [],
            rolecaplist: [],
            userroledata: [],
            userrole_index: -1,
            roledlg: false,
         };
      },
      methods: {
         goBack() {
            this.$router.go(-1);
         },
         async addRole() {
            this.roledlg = true;
         },

         removeRole() {
            if (this.userrole_index > -1) {
               this.userroledata.splice(this.userrole_index, 1);
               this.rolecaplist = [];
            }
         },

         onUserRoleClick(item, row) {
            row.select(true);
            this.userrole_index = row.index;
            this.rolecaplist = item.rolecaplist;
         },

         onRoleSelect(item) {
            this.roledlg = false;
            if (this.userroledata.findIndex((role) => role.role_id == item.role_id) === -1) {
               this.userroledata.push(item);
            }
         },

         captableRowClick(item, row) {
            row.select(true);
         },

         async SaveUser() {
            await this.$http({
               url: "/common/saveuser.php",
               data: {
                  useremail: this.edit_user_email,
                  username: this.edit_user_name,
                  userstatus: this.edit_user_status.id,
                  usertype: this.edit_user_type.id,
                  userroles: this.userroledata,
                  userid: this.$globalstore.user.userid,
               },
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               method: "POST",
            }).then((response) => {
               if (!response.data.error) {
                  this.goBack();
               } else {
                  this.ShowMessage({title: "Error", message: response.data.message, color: "red"});
                  // console.log("Error saving user. Message is " + response.data.message);
               }
            });
         },
      },
   };
</script>
